import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { YearWithoutValidatedDocument } from '@interfaces/accounting-data-standardization/responses/document-analysis-situation.response';

/** Pedido de abrir um documento pelo id (mesmo formato do link compartilhável `doc` + `docCompanyId`). */
export interface DocumentOpenRequest {
  companyId: string;
  extractionId: string;
}

/**
 * Faixa amarela do topo da lista da Padronização (card 3700): uma por ano que não aparece na Análise Econômica por
 * falta de documento validado de Estrutura Contábil. A frase vem pronta do backend (`message`). Com exatamente um
 * documento esperando conferência (`pendingExtractionId`), o botão "Conferir e validar" abre direto nele; sem isso, o
 * botão filtra a lista pelo ano.
 */
@Component({
  selector: 'app-years-without-document-banner',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './years-without-document-banner.component.html',
  styleUrl: './years-without-document-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YearsWithoutDocumentBannerComponent {
  readonly years = input<YearWithoutValidatedDocument[]>([]);
  /** Mostra o nome da empresa na faixa (lista com mais de uma empresa). */
  readonly showCompanyName = input<boolean>(false);

  readonly documentOpenRequested = output<DocumentOpenRequest>();
  readonly yearFilterRequested = output<number>();

  protected trackYear(item: YearWithoutValidatedDocument): string {
    return `${item.companyId}-${item.year}`;
  }

  protected onAction(item: YearWithoutValidatedDocument): void {
    if (item.pendingExtractionId) {
      this.documentOpenRequested.emit({
        companyId: item.companyId,
        extractionId: item.pendingExtractionId,
      });
      return;
    }
    this.yearFilterRequested.emit(item.year);
  }
}
